import React, { FormEvent, useEffect, useState } from 'react';
import './NewDossier.scss';
import { DashboardLayout } from '../../layouts/dashboard-layout/DashboardLayout';
import { useHistory, useLocation } from 'react-router-dom';
import Form from 'react-bootstrap/esm/Form';
import Col from 'react-bootstrap/esm/Col';
import Alert from 'react-bootstrap/esm/Alert';
import Button from 'react-bootstrap/esm/Button';
import Spinner from 'react-bootstrap/esm/Spinner';
import { Api } from '../../api';
import { DossierV2 } from '../../models/DossierV2';
import { ERouterPath } from '../../features/router/ERouterPath';
import queryString from 'querystring';
import { User } from '../../models/User';
import { UserAccountRoleEnum, UserRelationRoleEnum } from '../../api/types';
import { Dossier } from '../../models/Dossier';
import { useDispatch } from 'react-redux';
import { sessionActions } from '../../app/session/actions';

export const AddPersonToDossier = (): JSX.Element => {
  const history = useHistory();
  const location = useLocation();
  const [dossier, setDossier] = useState<DossierV2|undefined>(undefined);
  const [person, setPerson] = useState<User|undefined>(undefined);
  const [error, setError] = useState<string>('');
  const [submitting, setSubmitting] = useState<boolean>(false);
  const dispatch = useDispatch();
  const loaded = !!dossier && !!person;

  const allowedRoles = [UserRelationRoleEnum.client, UserRelationRoleEnum.responsibleParty, UserRelationRoleEnum.thirdParty];
  if (person && [UserAccountRoleEnum.caregiver, UserAccountRoleEnum.adminCaregiver].includes(person.accountRole)) {
    allowedRoles.push(UserRelationRoleEnum.caregiver);
  }

  const [role, setRole] = useState<UserRelationRoleEnum>(allowedRoles[0]);

  const parameters = queryString.parse(location.search.replace(/^\?/, ''));
  const addToDossier = +(parameters['add-to-dossier'] || '') || undefined;
  const personId = +(parameters['add-person'] || '') || undefined;

  useEffect(() => {
    if (!addToDossier) {
      setError('add-to-dossier get parameter mist');
      return;
    }
    Api.getDossierV2(addToDossier)
      .then(dossier => setDossier(dossier))
      .catch(() => setError('Laden mislukt'));
  }, [addToDossier]);

  useEffect(() => {
    if (!personId) {
      setError('add-person get parameter mist');
      return;
    }
    Api.getPerson(personId)
      .then(person => setPerson(person))
      .catch(() => setError('Laden mislukt'));
  }, [personId]);

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();

    if (!dossier || !person) {
      setError('Toevoegen mislukt door een onverwachte fout');
      return;
    }

    setSubmitting(true);
    Api.addPersonToDossier({ dossierId: dossier.id, person, role })
      .then(() => Api.getDossierWithUserRelation(dossier.id))
      .then((dossierWithRelation) => {
        dispatch(sessionActions.setDossier(dossierWithRelation));
        history.push(ERouterPath.manageDossier);
      })
      .catch(() => setError('Toevoegen mislukt door een onverwachte fout'))
      .finally(() => setSubmitting(false));
  };

  const renderForm = () => {
    if (!person || !dossier) {
      return null;
    }
    return <>
      <h2><strong>{person.name}</strong> toevoegen aan dossier <strong>{dossier.name}</strong></h2>
      <Form className="add-to-dossier__form" onSubmit={handleSubmit}>
        <Form.Row>
          <Form.Group as={Col} className="form__item">
            <Form.Label>Rol</Form.Label>
            <Form.Control className="add-to-dossier-input__role" as="select" value={role} onChange={e => setRole(e.target.value as UserRelationRoleEnum)}>
              { allowedRoles.map(role => <option key={role} value={role}>{Dossier.getRoleText(role, { capitalize: true })}</option>) }
            </Form.Control>
          </Form.Group>

          <Form.Group as={Col} className="form__item add-to-dossier__submit">
            <Button className="add-to-dossier__submit-btn" type="submit" disabled={submitting}>
              {submitting && <Spinner animation="border" variant="light" />}
              Toevoegen aan dossier
            </Button>
          </Form.Group>
        </Form.Row>
      </Form>
    </>;
  };

  return (
    <DashboardLayout className="new-dossier" noTabs={true} backButton={true}>
      { (loaded && !error) && renderForm() }
      { (!loaded && !error) && <Spinner animation="border" role="status" /> }
      { (error) && <Alert variant="danger">{error}</Alert> }
    </DashboardLayout>
  );
};
